export const USER_TYPE = {
  administrator: "administrator",
  creator: "creator",
  orgAdmin: "orgAdmin",
  user: "user",
  creatorLite: "creator lite",
} as const;

export type TUser = {
  createdAt: string;
  currentUserName: string;
  email: string;
  firstLogin: null | string;
  firstName: string;
  distinctId?: string;
  lastUpdated: string;
  oktaId: string;
  orgId: string;
  type: (typeof USER_TYPE)[keyof typeof USER_TYPE];
  migratedAt?: string;
  updatedAt: string;
  _id: string;
  firstAnalytics?: string;
  firstViewEditor?: string;
  autosaveCount?: number;
  profileCompleted?: boolean;
  firstSharedAt?: string;
  walkthrough?: {
    hasSkipped: boolean;
    lastStepIndex: number;
  };
  onboarding?: {
    modalShownAt?: string;
    platformTour?: {
      status: "finished" | "skipped";
      lastStepIndex: number;
      endedAt: string;
    };
    tasks?: Record<
      string,
      { completedAt: string | null; verified: boolean; source: string }
    >;
  };
  profile?: {
    picture: string | null | undefined;
    calendar: string | null | undefined;
    color: string | null | undefined;
    theme: string | null | undefined;
    role: string | null | undefined;
    phone: string | null | undefined;
    department?: string | null;
    website?: string | null;
    linkedin?: string | null;
    location?: string | null;
    address?: string | null;
    signature?: string | null;
    /** Profile custom fields, keyed by variable name (`sender_<slug>`). */
    customFields?: Record<string, string | null>;
  };
  skipAutosave?: boolean;
};
